// extracted by mini-css-extract-plugin
export var products__slider = "products-module--products__slider--2YAIq";
export var products__sliderContainer = "products-module--products__sliderContainer--NcWeH";
export var products__sliderTitle = "products-module--products__sliderTitle--q9Fpe";
export var products__card = "products-module--products__card--bQWkm";
export var products__cardGradient = "products-module--products__cardGradient--QhRBO";
export var products__cardTitle = "products-module--products__cardTitle--1LcKi";
export var products__cardDesc = "products-module--products__cardDesc--r+7tR";
export var products__cardLink = "products-module--products__cardLink--oDQmA";
export var products__cardMedia = "products-module--products__cardMedia--Y9Wk3";